var React = require('react');

function PlayCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.231 14.875c1.025.575 1.025 2.056 0 2.625l-11 6.313c-.994.55-2.231-.162-2.231-1.313v-13c0-1.156 1.244-1.862 2.231-1.313zM31.5 16c0 8.563-6.938 15.5-15.5 15.5S.5 24.562.5 16 7.438.5 16 .5 31.5 7.438 31.5 16zm-28 0c0 6.906 5.594 12.5 12.5 12.5S28.5 22.906 28.5 16 22.906 3.5 16 3.5 3.5 9.094 3.5 16z"}));
}

PlayCircle.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = PlayCircle;

PlayCircle.default = PlayCircle;
